'use client';

import { useState } from 'react';

import MobileAdProfiles from '@/constants/ad/mobile';

import AdSlot from '@/components/atoms/Ad/Adslot';

const ADSLotBottom = () => {
  const [showAd, setShowAd] = useState(true);

  if (!showAd) return null;

  return (
    <div className='fixed bottom-[50px] left-0 right-0 z-[100] flex items-center justify-center'>
      <div className='relative'>
        <button
          className='bg-[hsla(0, 0%, 100%, 0.3)] border-gray-blue text-gray-light absolute right-0 top-[-20px] z-[100] flex h-5 w-5 cursor-pointer items-center justify-center border border-solid text-xl'
          onClick={() => setShowAd(false)}
          aria-label='關閉廣告'
        >
          ×
        </button>
        <AdSlot profile={MobileAdProfiles.dynamicFooterAdPopup} />
      </div>
    </div>
  );
};

export default ADSLotBottom;
